import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "persona", "filter", "demographics", "demographicsToggle", "estimatePanel", "estimateResult",
    "loadingState", "clientErrorState", "serverErrorState", "next", "nextNote"
  ]
  static values = { autoEstimate: Boolean }

  static estimateDelay = 700

  connect() {
    if (this.autoEstimateValue) this.queueEstimate()
  }

  disconnect() {
    this.cancelQueuedEstimate()
    this.cancelActiveSubmission()
  }

  beginEstimate() {
    this.cancelQueuedEstimate()
    this.element.setAttribute("aria-busy", "true")
    if (this.hasEstimatePanelTarget) this.estimatePanelTarget.setAttribute("aria-busy", "true")
  }

  submissionStarted(event) {
    this.activeSubmission = event.detail.formSubmission
  }

  submissionEnded(event) {
    if (this.activeSubmission === event.detail.formSubmission) this.activeSubmission = null
    this.element.removeAttribute("aria-busy")
    if (this.hasEstimatePanelTarget) this.estimatePanelTarget.removeAttribute("aria-busy")

    if (!event.detail.fetchResponse) this.showConnectionError()
  }

  selectPersona(event) {
    const filters = JSON.parse(event.currentTarget.dataset.filters || "{}")

    this.filterTargets.forEach(input => {
      const selectedValues = filters[input.dataset.filterKey] || []
      input.checked = selectedValues.includes(input.value)
    })

    this.queueEstimate()
  }

  filterChanged() {
    this.queueEstimate()
  }

  toggleDemographics() {
    this.demographicsTarget.classList.toggle("hidden")
    if (this.hasDemographicsToggleTarget) {
      this.demographicsToggleTarget.setAttribute("aria-expanded", String(!this.demographicsTarget.classList.contains("hidden")))
    }
  }

  retryEstimate(event) {
    event.preventDefault()
    this.queueEstimate(0)
  }

  queueEstimate(delay = this.constructor.estimateDelay) {
    this.cancelQueuedEstimate()
    this.cancelActiveSubmission()

    if (this.hasEstimateResultTarget) this.estimateResultTarget.classList.add("hidden")
    if (this.hasClientErrorStateTarget) this.clientErrorStateTarget.classList.add("hidden")
    if (this.hasServerErrorStateTarget) this.serverErrorStateTarget.classList.add("hidden")
    if (this.hasLoadingStateTarget) this.loadingStateTarget.classList.remove("hidden")
    if (this.hasEstimatePanelTarget) this.estimatePanelTarget.setAttribute("aria-busy", "true")

    if (this.hasNextTarget) {
      this.nextTarget.removeAttribute("href")
      this.nextTarget.setAttribute("aria-disabled", "true")
      this.nextTarget.setAttribute("tabindex", "-1")
    }
    if (this.hasNextNoteTarget) this.nextNoteTarget.textContent = "Checking the updated matching audience before continuing."

    this.estimateTimer = window.setTimeout(() => this.element.requestSubmit(), delay)
  }

  cancelQueuedEstimate() {
    if (!this.estimateTimer) return

    window.clearTimeout(this.estimateTimer)
    this.estimateTimer = null
  }

  cancelActiveSubmission() {
    if (!this.activeSubmission) return

    this.activeSubmission.stop()
    this.activeSubmission = null
  }

  showConnectionError() {
    if (this.hasLoadingStateTarget) this.loadingStateTarget.classList.add("hidden")
    if (this.hasClientErrorStateTarget) this.clientErrorStateTarget.classList.remove("hidden")
    if (this.hasEstimatePanelTarget) this.estimatePanelTarget.removeAttribute("aria-busy")
    if (this.hasNextNoteTarget) this.nextNoteTarget.textContent = "We couldn’t check this lead list. Try again before continuing."
  }
}
